import React from 'react';
import { Button, Col, ConfigProvider, Form, Input, Modal, Row, Select, TreeSelect } from 'antd';
import { BiCheck, BiX } from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import { PostProjectesIdTasques } from "../../../dao/abp/PostProjectesIdTasques";
import TextArea from "antd/es/input/TextArea";
import { PostProjectesIdGrupIdAlumneIdNp } from "../../../dao/abp/PostProjectesIdGrupIdAlumneIdNp";

interface Props {
    alumnes: [],
    srpint: any, // Recieves the whole sprint object
    grup: string,
    projecte: string,
    visible: boolean;
    onClose: (value: boolean) => void;
}

const AvaluacioMassivaModal: React.FC<Props> = (props: Props) => {
    const [form] = Form.useForm();

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);

        // Regex capturing group for value inside parens
        const match = formData.avaluacio.match(/\(([^)]+)\)/);
        const valueInParenthesis = match ? parseFloat(match[1]) : 0;

        // Pass sprint ID instead of object string
        const sprintId = props.srpint?.id || props.srpint;

        await PostProjectesIdGrupIdAlumneIdNp(props.projecte, props.grup, formData.id_alumne, valueInParenthesis, sprintId + "")

        props.onClose(true);
    }

    const handleCancel = () => {
        props.onClose(false);
    };

    // Determine context (Open/Closed)
    // Logic matches AppSider: prioritize dates, fallback to estado
    const isClosed = (() => {
        const s = props.srpint;
        if (!s || typeof s !== 'object') return false; // Default to Open if unknown

        // Try date check first
        if (s.data_final) {
            const safeStr = s.data_final.replace(' ', 'T');
            const end = new Date(safeStr);
            if (!isNaN(end.getTime()) && new Date() > end) return true;
        }

        // Fallback to estado
        if (s.estado === 'cerrado') return true;
        if (s.con_retraso === 1) return true; // Check if this property exists on object

        return false;
    })();

    const gradeOptions = isClosed ? [
        'P(0)', 'NP(1)', 'M(2)', 'S(5)', 'B*(6.5)', 'MB*(8.5)'
    ] : [
        'P(0)', 'NP(1)', 'M(2)', 'S(5)', 'B(7.5)', 'MB(9)', 'E(10)'
    ];

    const sprintDisplayValue = (() => {
        const s = props.srpint;
        if (!s) return '';
        if (typeof s === 'string' || typeof s === 'number') return s;
        if (s.label) return s.label;
        if (s.id) return `Sprint ${s.id}`;
        return 'Sprint Actual';
    })();

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Editar Projecte"
                open={props.visible}
                onCancel={handleCancel}
                footer={[
                ]}
                width={500}
            >
                <Form form={form} onFinish={handleSubmit}>
                    <hr />
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="GRUP" name="id" initialValue={props.grup}>
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="Sprint" name="sprint" initialValue={sprintDisplayValue}>
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="Projecte" name="projecte" initialValue={props.projecte}>
                                <Input disabled />
                            </Form.Item>
                            <Form.Item label="Alumne" name="id_alumne"
                                rules={[{ required: true, message: 'Aquest camp es obligatori' }]}>
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder="Seleccionar alumno"
                                >
                                    {props.alumnes?.map((alumne: any) => (
                                        <Select.Option key={alumne.id_usuari} value={alumne.id_usuari}>
                                            {alumne.nom}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item label="Nota" name="avaluacio"
                                rules={[{ required: true, message: 'Aquest camp es obligatori' }]}>
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder="Seleccionar nota"
                                >
                                    {gradeOptions.map((val: any) => (
                                        <Select.Option key={val} value={val}>
                                            {val}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <hr />
                    <Row gutter={[16, 16]}>
                        <Col span={1}>
                            <Form.Item wrapperCol={{ offset: 0, span: 16 }}>
                                <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{ backgroundColor: AvaluacioColors.colors.color6 }}><BiCheck /></Button>
                            </Form.Item>
                        </Col>
                        <Col span={2}>
                        </Col>
                        <Col span={1}>
                            <Button title={"Cancelar"} style={{ backgroundColor: AvaluacioColors.colors.color1 }}
                                onClick={handleCancel}><BiX /></Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default AvaluacioMassivaModal;
